import useSWR from "swr";
import { camelize } from "camelscore";

import getCategories, {
  CACHE_KEY,
} from "storefront/GrailedAPI/v1/Config/getCategories";

import type { CategoriesV2 } from "storefront/Categories";
import type { ResponseData } from "storefront/GrailedAPI/v1/Config/getCategories";
import { failed, loading, Resource } from "storefront/lib/Resource";
import { completed } from "./useSubmitState";

let preloadedDataFromWindow: ResponseData | undefined;

if (typeof window !== "undefined" && window.CATEGORY_DATA) {
  preloadedDataFromWindow = camelize(window.CATEGORY_DATA);
}

const options = {
  suspense: true,
  revalidateIfStale: false,
  revalidateOnReconnect: false,
  revalidateOnFocus: false,
  fallbackData: preloadedDataFromWindow,
};

/**
 * @name useCategories
 * @description Fetches listing categories using the useSWR hook in
 * functional components.
 *
 */
const useCategories = (): Resource<CategoriesV2> => {
  const { data, error } = useSWR<ResponseData, Error>(
    CACHE_KEY,
    getCategories,
    options,
  );

  if (error) {
    return failed(Error(`Error fetching categories: ${error.message}`));
  }

  if (!data) {
    return loading;
  }

  return completed<CategoriesV2>(data.categories);
};

export default useCategories;
